<template></template>
<script>
    import PreviewTopbarSection from "./PreviewTopbarSection";
    import PageTopbarSection from '../../../components/pagesbuilder/sections/PageTopbarSection.vue';

    export default {
        name: "PreviewCustomTopbarSection",
        mixins: [PreviewTopbarSection, PageTopbarSection],
        data() {
            return {}
        },
        methods: {
           
        }
    }
</script>

